import { useEffect, useState } from "react";
import { subscribeStateLog } from "@/lib/firestore/stateLog";
import type { StateTransitionLog } from "@/types";

export function useStateLog(projectId: string | null) {
  const [entries, setEntries] = useState<StateTransitionLog[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!projectId) {
      setEntries([]);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    return subscribeStateLog(
      projectId,
      (data) => {
        setEntries(data);
        setLoading(false);
        setError(null);
      },
      (err) => {
        setError(err.message);
        setLoading(false);
      },
    );
  }, [projectId]);

  return { entries, loading, error };
}
